module.exports = __webpack_public_path__ + "img/train.8c0ced9a.png";